export enum PaginationType {
  Page = 'page',
  Next = 'next',
  Previous = 'previous',
  StartEllipsis = 'start-ellipsis',
  EndEllipsis = 'end-ellipsis',
}
